import type { App } from "@open-booking/server";
import type { RequestOtpPayload, VerifyOtpPayload } from "@open-booking/shared";
import { createApi } from "@reduxjs/toolkit/query/react";
import { type EdenCall, edenBaseQuery } from "@/src/common/lib/eden-base-query";

type RequestOtpResponse = App["~Routes"]["auth"]["request-otp"]["post"]["response"]["200"];
type VerifyOtpResponse = App["~Routes"]["auth"]["verify-otp"]["post"]["response"]["200"];
type RefreshResponse = App["~Routes"]["auth"]["refresh"]["post"]["response"]["200"];
type CsrfResponse = App["~Routes"]["auth"]["csrf"]["get"]["response"]["200"];
type MeResponse = App["~Routes"]["auth"]["me"]["get"]["response"]["200"];

export const authApi = createApi({
	reducerPath: "authApi",
	baseQuery: edenBaseQuery(),
	endpoints: (builder) => ({
		requestOtp: builder.mutation<RequestOtpResponse, RequestOtpPayload>({
			query:
				(payload): EdenCall<RequestOtpResponse> =>
				(client) =>
					client.auth["request-otp"].post(payload),
		}),
		verifyOtp: builder.mutation<VerifyOtpResponse, VerifyOtpPayload>({
			query:
				(payload): EdenCall<VerifyOtpResponse> =>
				(client) =>
					client.auth["verify-otp"].post(payload),
		}),
		refresh: builder.mutation<RefreshResponse, void>({
			query: (): EdenCall<RefreshResponse> => (client) => client.auth.refresh.post(),
		}),
		fetchCsrf: builder.query<CsrfResponse, void>({
			query: (): EdenCall<CsrfResponse> => (client) => client.auth.csrf.get(),
		}),
		fetchMe: builder.query<MeResponse, void>({
			query: (): EdenCall<MeResponse> => (client) => client.auth.me.get(),
		}),
	}),
});

export const { useRequestOtpMutation, useVerifyOtpMutation, useRefreshMutation, useFetchCsrfQuery, useFetchMeQuery } = authApi;
